import component from './favoriteButton.component'
import service from './favorite.service'
import './favoriteButton.scss'

let module = angular.module('favoriteButton', [])
	.component('favoriteButton', component)
	.service('Favorite', service)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/favoriteButton/favoriteButton.js